module.exports = [{
  "name": "theme:starter",
  "socketAddress": "ws://127.0.0.1",
  "socketPort": "8809",
  "mainCSS": "/themes/starter/assets/css/theme.css"
}];
